import { render, staticRenderFns } from "./GroupAccessView.vue?vue&type=template&id=71cfa231&scoped=true&"
import script from "./GroupAccessView.vue?vue&type=script&lang=ts&"
export * from "./GroupAccessView.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71cfa231",
  null
  
)

export default component.exports